window.addEventListener("DOMContentLoaded", function () {

    window.recalculateBuffer = true;

    const spinner = document.querySelector('.spinner');
    const tamponCheckbox = document.getElementById('tamponCheckbox');
    const tunnel = document.getElementById('tunnelSlider');
    const durationSpan = document.getElementById('duration').querySelector('span');
    const distanceSpan = document.getElementById('distance').querySelector('span');
    const filterTooltip = document.getElementById('tooltip-filter');
    const closeModalFilterTooltip = document.getElementById('close-modal-tooltip-filter');

    const datasetUrl = window.location.origin + '/get-poi-dataset';
    const poiSourceName = 'poi';
    const poiLayerName = 'poi-layer';
    const bufferSourceName = 'buffer-destination';
    const bufferLayerName = 'buffer-destination-layer';
    const directionSourceName = 'directions';
    let poiDataSource = null;
    let filteredDataSource = [];
    const filterActive = {};

    const initialBounds = [[-124.848974, 24.396308], [-66.885444, 49.384358]];
    const maxZoom = 15;
    const maxPitch = 0;
    const minPitch = 0;

    let openedPopup = null;

    mapboxgl.accessToken = mapbox_env.front_token;
    const map = new mapboxgl.Map({
        container: 'map',
        style: `mapbox://styles/${mapbox_env.username}/${mapbox_env.map_style_id}`,
        maxZoom: maxZoom,
        maxPitch: maxPitch,
        minPitch: minPitch,
        bounds: initialBounds
    });

    const geolocateControl = new mapboxgl.GeolocateControl({
        positionOptions: {
            enableHighAccuracy: true
        },
        // When active the map will receive updates to the device's location as it changes.
        trackUserLocation: true,
        // Draw an arrow next to the location dot to indicate which direction the device is heading.
        showUserHeading: true
    });

    const loadDataSource = async () => {
        if (!poiDataSource) {
            poiDataSource = await fetch(datasetUrl)
                .then((res) => res.json())
                .then((res) => {
                    return res;
                });
        }
    };

    let initialZoom = 5;

    // disable map rotation using right click + drag
    map.dragRotate.disable();

    // allow user to zoom and change map orientation
    map.addControl(new mapboxgl.NavigationControl());

    map.addControl(geolocateControl);

    const createNewMapboxPopupInstance = (properties, coords) => {
        if (openedPopup) {
            openedPopup.remove();
        }
        openedPopup = new mapboxgl.Popup({
            closeButton: false
        })
            .setLngLat(coords)
            .setHTML(window.getPoiPopup(
                properties,
                coords
            ))
            .addTo(map);
    }

    const icons  = [
        {
            id: 'see',
            url: '/wp-content/themes/lostintheusa/dist/images/btn-see-color.png'
        },
        {
            id : 'sleep',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-sleep-color.png'
        },
        {
            id : 'food',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-food-color.png'
        },
        {
            id : 'walk',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-walk-color.png'
        },
        {
            id : 'drink',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-drink-color.png'
        },
        {
            id : 'music-lo',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-music-color.png'
        },
        {
            id : 'movie',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-cinema-color.png'
        },
        {
            id : 'nature',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-nature-color.png'
        },
        {
            id : 'animal',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-animals-color.png'
        },
        {
            id : 'shop-lo',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-shop-color.png'
        },
        {
            id : 'drive',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-drive-color.png'
        },
        {
            id : 'weird',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-weird-color.png'
        },
        {
            id : 'city',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-city-color.png'
        },
        {
            id : 'state',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-state-color.png'
        },
        {
            id : 'park',
            url : '/wp-content/themes/lostintheusa/dist/images/btn-park-color.png'
        }
    ];

    /* Create a list of promises for the icon loading*/
    const image_promises = icons.map( icon => {
        // return a promise per icon
        return new Promise(function(resolve,reject){
            // load the image
            map.loadImage(icon.url, function(error,data){
                // if error reject the promise
                if (error){
                    console.log(`Error with ${icon.id}`);
                    console.error(error);
                    reject(error);
                } else {
                    // return the data in the icon
                    resolve([icon, data]);
                }
            });
        });
    });

    map.on('load', async () => {
        initialZoom = Math.floor(map.getZoom());
        await Promise
            .all(image_promises)
            .then(async (icons) => {
                // Add the icons to the map
                icons.forEach( icon_data => {
                    const icon = icon_data[0];
                    const data = icon_data[1];
                    map.addImage(icon.id, data);
                });

                /// layers & source definitions
                map.addSource(poiSourceName, {
                    type: 'geojson',
                    data: datasetUrl
                });

                map.addSource(directionSourceName, {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': []
                    }
                });

                map.addSource(bufferSourceName, {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': []
                    }
                });

                map.addLayer({
                    'id': bufferLayerName,
                    'type': 'fill',
                    'source': bufferSourceName,
                    'paint': {
                        'fill-color': '#c84c46',
                        'fill-opacity': 0.2,
                        'fill-outline-color': '#c84c46',
                    },
                    'layout' : {
                        'visibility': tamponCheckbox.checked ? 'visible' : 'none'
                    }
                });

                window.getMapboxDirectionsStyles(directionSourceName).forEach((style) => {
                    // only add the default style layer if a custom layer wasn't provided
                    map.addLayer(style);
                });

                map.addLayer({
                    id: poiLayerName,
                    type: 'symbol',
                    source: poiSourceName,
                    'layout': {
                        'icon-image': [
                            'match', // Use the 'match' expression: https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
                            ['get', 'main_category'], // Use the result 'coalition' property
                            'see', 'see',
                            'sleep', 'sleep',
                            'food', 'food',
                            'walk', 'walk',
                            'drink', 'drink',
                            'music', 'music-lo',
                            'cinema', 'movie',
                            'nature', 'nature',
                            'animals', 'animal',
                            'shop', 'shop-lo',
                            'drive', 'drive',
                            'weird', 'weird',
                            'city', 'city',
                            'state', 'state',
                            'park', 'park',
                            'city' // default value
                        ],
                        'icon-size': 0.3,
                        'icon-allow-overlap': true,
                        'visibility': 'none'
                    },
                });

                window.addWaypointsToMapbox();

                map.on('mouseenter', poiLayerName, () => {
                    map.getCanvas().style.cursor = 'pointer'
                });
                map.on('mouseleave', poiLayerName, () => {
                    map.getCanvas().style.cursor = ''
                });

                map.on('click', poiLayerName, (e) => {
                    // Copy coordinates array.
                    const coordinates = e.features[0].geometry.coordinates.slice();

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    createNewMapboxPopupInstance(e.features[0].properties, coordinates);
                });

                spinner.classList.add('hidden');
            });
    });

    map.on('zoom', () => {
        if (Math.ceil(map.getZoom()) > initialZoom + 1) {
            map.setLayoutProperty(poiLayerName, 'visibility', 'visible');
        }
    });

    tamponCheckbox.addEventListener('change', async () => {
        if (tamponCheckbox.checked) {
            if (
                window.currentRoadtrip?.data?.startStep?.position?.length > 0 &&
                window.currentRoadtrip?.data?.endStep?.position?.length > 0
            ) {
                if (window.recalculateBuffer) {
                    await addBufferToDestination(tunnel.value);
                } else {
                    map.getSource(poiSourceName).setData({
                        'type': 'FeatureCollection',
                        'features': filteredDataSource
                    });
                }
                map.setLayoutProperty(bufferLayerName, 'visibility', 'visible');
            }
        } else {
            map.setLayoutProperty(bufferLayerName, 'visibility', 'none');
            map.getSource(poiSourceName).setData(poiDataSource);
        }
    });

    window.addWaypointsToMapbox = async () => {
        let roadtripCoordinatesString = '';
        const allSteps = [];

        if (!window.roadtripIsValid(window.currentRoadtrip)) {
            return;
        }

        window.removeRoutesFromMapboxDirections();

        const startPosition = window.currentRoadtrip.data.startStep.position.split(',');
        const endPosition = window.currentRoadtrip.data.endStep.position.split(',');

        roadtripCoordinatesString = startPosition + ';';
        allSteps.push(startPosition);

        if (window.currentRoadtrip.data.steps) {
            const steps = window.currentRoadtrip.data.steps;
            steps.forEach((step, index) => {
                if (step.position.length > 0) {
                    roadtripCoordinatesString += step.position + ';';
                    allSteps.push(step.position.split(','));
                }
            });
        }

        roadtripCoordinatesString += endPosition;
        allSteps.push(endPosition);

        await mapboxGetDirectionByCoordinates(roadtripCoordinatesString).then(async (res) => {
            const directions = res.routes;

            const geojson = {
                type: 'FeatureCollection',
                features: []
            };

            let totalDistanceInMeters = 0;
            let totalDurationInSeconds = 0;
            directions.forEach((feature, index) => {
                totalDistanceInMeters += feature.distance;
                totalDurationInSeconds += feature.duration;

                const decoded = window.decodePolyline(feature.geometry, 5).map(function (c) {
                    return c.reverse();
                });

                geojson.features = geojson.features.concat(
                    window.directionSegmentation(feature, decoded, index)
                );

                // Collect any possible waypoints from steps
                allSteps.forEach((stepCoordinates, index) => {
                    let type = 'waypoint';
                    if (index === 0) {
                        type = 'origin';
                    } else if (index === allSteps.length - 1) {
                        type = 'destination';
                    }

                    geojson.features.push({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: stepCoordinates,
                        },
                        properties: {
                            id: 'waypoint',
                            type: type,
                            label: String.fromCharCode('A'.charCodeAt(0) + index)
                        }
                    });
                });
            });

            window.currentRoadtrip.data.duration = totalDurationInSeconds;
            window.currentRoadtrip.data.distance = Math.round(totalDistanceInMeters / 1000);
            distanceSpan.innerHTML = Math.round(totalDistanceInMeters / 1000) + ' km';
            durationSpan.innerHTML = window.displayTimeDurationInDays(totalDurationInSeconds);

            window.updateCurrentRoadtrip(currentRoadtrip);

            const bounds = new mapboxgl.LngLatBounds();

            allSteps.forEach(function(stepCoordinates) {
                bounds.extend(stepCoordinates);
            });

            map.fitBounds(bounds, {padding: 20});
            map.getSource(directionSourceName).setData(geojson);

            if (tamponCheckbox.checked) {
                await addBufferToDestination(tunnel.value);
            }
        });

        window.recalculateBuffer = true;
    }

    const addBufferToDestination = async (rangeInKm) => {
        const directionsMapSource = map.getSource(directionSourceName);

        if (directionsMapSource) {
            if (!directionsMapSource._data.features[0]) {
                await new Promise((resolve) => setTimeout(resolve, 500));
                return addBufferToDestination(rangeInKm);
            }

            const points = turf.lineString(
                window.reducePoint(directionsMapSource._data.features[0].geometry.coordinates)
            );

            const destinationBuffer = turf.buffer(points, rangeInKm, {units: 'kilometers'});

            map.getSource(bufferSourceName).setData({
                'type': 'FeatureCollection',
                features: [destinationBuffer]
            });

            await loadDataSource();

            if (poiDataSource) {
                const filteredData = poiDataSource.features.filter((feature) => {
                    return turf.booleanPointInPolygon(feature, destinationBuffer);
                });

                filteredDataSource = filteredData;

                map.getSource(poiSourceName).setData({
                    'type': 'FeatureCollection',
                    'features': filteredData
                });

                window.recalculateBuffer = false;
            }
        }
    }

    window.removeRoutesFromMapboxDirections = () => {
        map.getSource(directionSourceName).setData({
            type: 'FeatureCollection',
            features: []  // <--- no features
        });
        map.getSource(bufferSourceName).setData({
            type: 'FeatureCollection',
            features: []  // <--- no features
        });
        if (poiDataSource) {
            map.getSource(poiSourceName).setData(poiDataSource);
        }
    }

    document.addEventListener('click', (e) => {
        let target = e.target.closest('.poi-card-add-roadtrip');

        if (target) {
            window.addPoiToRoadtrip({
                label: target.getAttribute('data-title'),
                position: target.getAttribute('data-position')
            });
            window.recalculateBuffer = true;
            return;
        }

        target = e.target.closest('.poi-card-add-bucketlist');

        if (target) {
            target.classList.remove('poi-card-add-bucketlist')
            target.classList.add('poi-card-remove-bucketlist')
            target.querySelector('span').innerHTML = 'Retirer de ma bucketlist';
            window.addPoiToBucketlist({
                id: target.getAttribute('data-id'),
                thumbnail: target.getAttribute('data-thumbnail'),
                category: target.getAttribute('data-category'),
                grade: target.getAttribute('data-grade'),
                title: target.getAttribute('data-title'),
                state: target.getAttribute('data-state'),
            });
            window.recalculateBuffer = true;
            return;
        }

        target = e.target.closest('.poi-card-remove-bucketlist');

        if (target) {
            target.classList.add('poi-card-add-bucketlist')
            target.classList.remove('poi-card-remove-bucketlist')
            target.querySelector('span').innerHTML = 'Ajouter à ma bucketlist';
            window.removePoiFromBucketlist({
                id: target.getAttribute('data-id')
            });
            window.recalculateBuffer = true;
        }
    });

    const addFilterToMap = () => {
        let filters = ['all'];

        Object.keys(filterActive).forEach((key) => {
            filters.push(filterActive[key]);
        });
        map.setFilter(poiLayerName, filters);
    }

    map.on('idle', () => {
        const buttonLayerIds = ['see', 'sleep', 'food', 'walk', 'drink', 'music', 'cinema', 'nature', 'animals', 'shop', 'drive', 'weird', 'city', 'state', 'park'];
        for (const id of buttonLayerIds) {
            let link = document.getElementById(id);
            link.onclick = function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isActive = this.getAttribute('data-active') === 'true';
                const currentFillColor = window.getComputedStyle(this.querySelector('svg')).fill;
                const currentBackgroundColor = window.getComputedStyle(this).backgroundColor;

                if (isActive) {
                    if (!filterActive.hasOwnProperty(this.id)) {
                        return;
                    }
                    delete filterActive[this.id];

                    addFilterToMap();

                    this.setAttribute('data-active', 'false');
                    this.style.backgroundColor = currentFillColor;
                    this.querySelector('svg').style.fill = currentBackgroundColor;
                    if (Object.keys(filterActive).length === 0) {
                        filterTooltip.classList.add('hidden');
                    }
                } else {
                    filterActive[this.id] = ['in', this.id, ['get', 'tags']];
                    addFilterToMap();

                    filterTooltip.querySelector('.tooltip-filter__text').innerHTML = Object.keys(filterActive).length > 1
                        ? 'La carte affiche les points d\'intérêts ayant une référence dans les catégories : <span>' + window.poi_category_translation(Object.keys(filterActive)) + '</span>'
                        : 'La carte affiche les points d\'intérêts ayant une référence dans la catégorie : <span>' + window.poi_category_translation(this.id) + '</span>';

                    this.setAttribute('data-active', 'true');
                    this.style.backgroundColor = currentFillColor;
                    this.querySelector('svg').style.fill = currentBackgroundColor;
                    filterTooltip.classList.remove('hidden');
                }
            };
        }
    });

    closeModalFilterTooltip.addEventListener('click', () => {
       filterTooltip.classList.add('hidden')
    });

    window.focusOnPoint = (coord, zoom = 7) => {
        map.flyTo({center: coord, zoom: zoom})
    }

    window.openPopupOnCoords = async (coords) => {
        if (!coords.hasOwnProperty('lon') || !coords.hasOwnProperty('lat')) {
            return;
        }

        await loadDataSource();

        const feature = poiDataSource.features.find((feature) => {
            const pointGeo = feature.geometry.coordinates; // lon, lat
            return coords.lon === pointGeo[0] && coords.lat === pointGeo[1];
        });

        if (feature) {
            createNewMapboxPopupInstance(feature.properties, [coords.lon, coords.lat]);
        }
    }

    const handleTunnelChange = window.debounce(async (ev) => {
        if (tamponCheckbox.checked) {
            await addBufferToDestination(tunnel.value);
        }
    }, 500);

    tunnel.addEventListener('change', handleTunnelChange);
});
